import { TIME_LEFT_TO_REFRESH_TOKEN } from '@/api/constants/timeLeftToRefreshToken.js'

const getTokenNeedsToBeUpdated = (tokenExpirationUnixTime) => {
  if (!tokenExpirationUnixTime) return false

  if (tokenExpirationUnixTime <= 0) return false

  const currentUnixTime = Date.parse(new Date()) / 1000
  const difference = tokenExpirationUnixTime - currentUnixTime

  if (difference <= 0) return false

  return difference <= TIME_LEFT_TO_REFRESH_TOKEN
}

export default getTokenNeedsToBeUpdated
